export default "__VITE_ASSET__e13881dc__"